import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Icon } from "./";

export function IconTextInput({ value, onChange, defaultIcon }) {
  // console.log('IconInput: ', value);
  const [inputValue, setInputValue] = useState(value);
  const [sourceTag, setSourceTag] = useState("");
  const [iconSetting, setIconSetting] = useState("");
  const [missingIcon, setMissingIcon] = useState(false);

  const iconRef = useRef();

  const handleChange = (ev) => {
    const { value } = ev.target;
    setInputValue(value.toLowerCase());
    processIconSettings(value);
    if (onChange) {
      onChange(ev);
    }
  };

  useLayoutEffect(() => {
    if (iconRef.current) {
      if (iconRef.current.getBoundingClientRect().height === 0) {
        return setMissingIcon(true);
      }
      return setMissingIcon(false);
    }
  }, [value]);

  useEffect(() => {
    processIconSettings(value);
  }, []);

  const processIconSettings = (value) => {
    const sourceQuery = value.toLowerCase().substr(0, 2);
    const sourceSubQuery = value.toLowerCase().substr(0, 3);

    // console.log(sourceQuery);
    // let iconSet = 'fa-fw';
    switch (sourceQuery) {
      case "fa": {
        let subSource = "";
        if (sourceSubQuery === "far") {
          subSource = " - Regular";
        }
        if (sourceSubQuery === "fas") {
          subSource = " - Solid";
        }
        if (sourceSubQuery === "fal") {
          subSource = " - Light";
        }
        if (sourceSubQuery === "fab") {
          subSource = " - Brands";
        }
        setIconSetting("fa-fw");
        setSourceTag(`Font Awesome 5 Pro${subSource}`);
        break;
      }
      case "ra": {
        setIconSetting("ra-fw");
        setSourceTag("RPG Awesome");
        break;
      }
      default: {
        setIconSetting("fa-fw");
        setSourceTag(undefined);
        break;
      }
    }
  };

  const displayedIcon =
    inputValue && inputValue.length > 0
      ? inputValue
      : defaultIcon
      ? defaultIcon
      : "far fa-times";

  const isDefault =
    !inputValue || (inputValue && inputValue.length === 0) ? true : false;

  return (
    <div className="chronos-input-component chronos-icon-input">
      <div className="input-group input-group-s">
        <div className="input-group-prepend">
          <button
            className={`chronos-icon-display btn btn-s btn-default ${
              isDefault ? " text-muted" : ""
            }`}
            type="button"
          >
            <Icon icon={displayedIcon + ` ${iconSetting}`} innerRef={iconRef} />
          </button>
        </div>
        <input
          type="text"
          value={value}
          onChange={handleChange}
          className="form-control"
          spellCheck={false}
        />
      </div>
      {/* <span className="chronos-text-input-source text-muted">{sourceTag}</span> */}
      <IconInputHelp
        source={sourceTag}
        icon={inputValue}
        isIconMissing={missingIcon}
      />
    </div>
  );
}

function IconInputHelp({ source, icon, isIconMissing }) {
  const showSource =
    source !== "" && (icon.indexOf("fa") === 0 || icon.indexOf("ra") === 0);
  // console.log('Props', source, icon);
  // console.log('Computed', showSource);
  return (
    <p className="chronos-text-input-source text-muted">
      {!showSource && (
        <React.Fragment>
          See{" "}
          <a href="https://fontawesome.com/icons?d=gallery" target="_blank">
            FontAwesome&nbsp;
            <i className="far fa-external-link" />
          </a>{" "}
          or{" "}
          <a
            href="https://nagoshiashumari.github.io/Rpg-Awesome/"
            target="_blank"
          >
            RPG Awesome&nbsp;
            <i className="far fa-external-link" />
          </a>{" "}
          for available icons.
          <br />
          You must use the full name for the icon, like{" "}
          <code className="chronos-code-text">far fa-house</code> (Font Awesome)
          or <code className="chronos-code-text">ra ra-aura</code> (RPG Awesome)
          for the icon
        </React.Fragment>
      )}
      {showSource && (
        <React.Fragment>
          {icon.indexOf("fa") === 0 && (
            <a href="https://fontawesome.com/icons?d=gallery" target="_blank">
              {source}&nbsp;
              <i className="far fa-external-link" />
            </a>
          )}
          {icon.indexOf("ra") === 0 && (
            <a
              href="https://nagoshiashumari.github.io/Rpg-Awesome/"
              target="_blank"
            >
              {source}&nbsp;
              <i className="far fa-external-link" />
            </a>
          )}
        </React.Fragment>
      )}
      {isIconMissing && (
        <React.Fragment>
          <br />
          {/* <br /> */}
          <span className="chronos-icon-input chronos-missing-icon">
            No icon found with that name.
          </span>
        </React.Fragment>
      )}
    </p>
  );
}
